import React, {Component} from 'react';

const Loader =()=>{
    return(
        <div class="lds-ring"><div></div><div></div><div></div><div></div></div>
    )
}
export default Loader;


// WEBPACK FOOTER //
// ./src/components/loader/loader.js